import * as React from 'react';
import moment from 'moment-timezone';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GET_COACHING_SESSION_INSTANCES_FOR_TIMEFRAME_QUERY from 'coaching/queries/GetCoachingSessionInstancesForTimeframe.gql';
import {
  GetCoachingSessionInstancesForTimeframe,
  GetCoachingSessionInstancesForTimeframe_coaching_getCoachingSessionInstancesForTimeframe,
} from 'coaching/queries/__generated__/GetCoachingSessionInstancesForTimeframe';
import TimezoneHelper from 'lib/timezones';

export type CoachingSessionInstanceWithDistanceLearningMetadata = GetCoachingSessionInstancesForTimeframe_coaching_getCoachingSessionInstancesForTimeframe;

export type Props = {
  hoursToLookBack: number;
  hoursToLookAhead: number;
  children: (props: {
    instances: CoachingSessionInstanceWithDistanceLearningMetadata[] | undefined;
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetCoachingSessionInstancesWithDistanceLearningMetadataContainer(
  props: Props
) {
  return (
    <Query<GetCoachingSessionInstancesForTimeframe>
      query={GET_COACHING_SESSION_INSTANCES_FOR_TIMEFRAME_QUERY}
      variables={{
        startDateTime: moment
          .utc()
          .subtract(props.hoursToLookBack, 'hour')
          .toISOString(),
        endDateTime: moment
          .utc()
          .add(props.hoursToLookAhead, 'hour')
          .toISOString(),
        timezone: TimezoneHelper.userTimezoneDefaultValue ?? 'America/Los_Angeles',
      }}
      pollInterval={30000}>
      {({ loading, error, data }) => {
        return props.children({
          instances: data?.coaching?.getCoachingSessionInstancesForTimeframe,
          loading,
          error,
        });
      }}
    </Query>
  );
}
